module.exports = __webpack_public_path__ + "img/file-earmark-easel-fill.58457307.svg";